<template>
  <div class="demeanor-detail">
    <div class="demeanor-detail-content">
      <div class="demeanor-detail-content-head">
        <div>志愿者风采</div>
        <div><img src="@/assets/line.png" alt="" /></div>
        <div>THE ELEGANT DEMEANOR OF VOLUNTEERS</div>
      </div>
      <div class="detail-main">
        <div><img :src="FILE_BASE_URL+this.navList[this.infoIndex].image" /></div>
        <div style="width:100%">
          <div>{{this.navList[this.infoIndex].name}}</div>
          <div>
            {{this.navList[this.infoIndex].introdution}}
          </div>
        </div>
      </div>
      <div class="detail-foot">
        <div @click="toLast">上一位</div>
        <div @click="toNext">下一位</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      navList:[],
      infoIndex: 0,
      item: {},
      nextIndex:0,
      lastIndex:0,
      FILE_BASE_URL:this.$API.FILE_BASE_URL
    };
  },
  mounted() {
    this.infoIndex = this.$route.query.infoIndex;
    this.navList = JSON.parse(localStorage.getItem('navList')) 
    this.queryVolunteerById(this.navList[this.infoIndex].id)
    if(this.infoIndex == 0){
      this.lastIndex = this.infoIndex 
    }else{
      this.lastIndex = parseInt(this.infoIndex) - 1
    }
    if(this.infoIndex  == this.navList.length - 1){
       this.nextIndex = this.infoIndex 
    }else{
       this.nextIndex = parseInt(this.infoIndex) + 1
    }
    
  },
  
  methods: {
    //点击次数统计
    queryVolunteerById(id) {
      let params = {
        id: id,
      };
      this.$API.queryVolunteerById(params);
    },
    //上一页
    toLast(){
      this.infoIndex = this.lastIndex
      if(this.infoIndex == 0){
      this.lastIndex = this.infoIndex 
    }else{
      this.lastIndex = parseInt(this.infoIndex) - 1
    }
    if(this.infoIndex  == this.navList.length - 1){
       this.nextIndex = this.infoIndex 
    }else{
       this.nextIndex = parseInt(this.infoIndex) + 1
    }
    },
    //下一页
    toNext(){
      this.infoIndex = this.nextIndex
      if(this.infoIndex == 0){
      this.lastIndex = this.infoIndex 
    }else{
      this.lastIndex = parseInt(this.infoIndex) - 1
    }
    if(this.infoIndex  == this.navList.length - 1){
       this.nextIndex = this.infoIndex 
    }else{
       this.nextIndex = parseInt(this.infoIndex) + 1
    }
    },

  },
};
</script>

<style lang="scss" scoped>
.demeanor-detail {
  width: 100%;
}
.demeanor-detail-content {
  width: 1200px;
  margin: 0 auto;
  padding: 40px 0 60px 0;
  .demeanor-detail-content-head {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    > div:nth-child(1) {
      font-size: 26px;
      font-family: MicrosoftYaHei, MicrosoftYaHei-Bold;
      font-weight: 700;
      color: #333333;
    }
    > div:nth-child(2) {
      margin-top: 12px;
    }
    > div:nth-child(3) {
      font-size: 12px;
      font-family: MicrosoftYaHei, MicrosoftYaHei-Regular;
      font-weight: 400;
      color: #999999;
      margin-top: 14px;
    }
  }
}
.detail-main {
  margin-top: 40px;
  display: flex;
  > div:nth-child(1) {
    img {
      width: 185px;
      height: 208px;
    }
  }
  > div:nth-child(2) {
    padding: 20px 20px 0 20px;
    border: 1px solid #e4e4e4;
    > div:nth-child(1) {
      font-size: 16px;
      font-family: MicrosoftYaHei, MicrosoftYaHei-Bold;
      font-weight: 700;
      color: #333333;
    }
    > div:nth-child(2) {
      font-size: 14px;
      font-family: MicrosoftYaHei, MicrosoftYaHei-Regular;
      font-weight: 400;
      color: #777777;
      margin-top: 8px;
      line-height: 26px;
    }
  }
}
.detail-foot {
  margin-top: 40px;
  display: flex;
  justify-content: center;
  > div:nth-child(1) {
    width: 76px;
    height: 26px;
    background: #f5f5f5;
    font-size: 13px;
    font-family: MicrosoftYaHei, MicrosoftYaHei-Regular;
    font-weight: 400;
    text-align: center;
    color: #777777;
    line-height: 26px;
    cursor: pointer;
    &:hover {
      color: #ffffff;
      background: #c8000e;
    }
  }
  > div:nth-child(2) {
    width: 76px;
    height: 26px;
    background: #f5f5f5;
    font-size: 13px;
    font-family: MicrosoftYaHei, MicrosoftYaHei-Regular;
    font-weight: 400;
    text-align: center;
    color: #777777;
    line-height: 26px;
    margin-left: 24px;
    cursor: pointer;
    &:hover {
      color: #ffffff;
      background: #c8000e;
    }
  }
}
</style>